module.exports = new __parcel__URL__("step-heartbeats.5fa6a10d.svg").toString();